module.exports = __webpack_public_path__ + "media/login/login_icon_ojocerrado-efbd73b4.svg";